export enum QueryKeysEnum {
  GET_WALLET = 'wallet_entries',
}
